import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Button, Card, Col, Form, Row, Modal } from 'react-bootstrap';
import { BsFileEarmarkExcel, BsPlusCircle, BsTrash } from 'react-icons/bs';
import * as XLSX from 'xlsx';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import RelojChecadorDataService from '../../../Services/Catalogos/RelojChecador'
import { DTOReporteChecadas } from './DTO/DTOReporteChecadas';
import { DTOGestionChecadasParams } from './DTO/DTOGestionChecadasParams';

export default function EntradasSalidasReloj() {
  const [data, setData] = useState<DTOReporteChecadas[]>([]);
  const [filteredData, setFilteredData] = useState<DTOReporteChecadas[]>([]);
  const [filtro, setFiltro] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [toastMsg, setToastMsg] = useState('');
  const [toastHeader, setToastHeader] = useState('');
  const [toastColor, setToastColor] = useState('');
  const [showToast, setShowToast] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalData, setModalData] = useState<{
    userId: number;
    fecha: string;
    tipo: 'entrada' | 'salida';
    numero: number;
    checkTime?: string;
  }>({ userId: 0, fecha: '', tipo: 'entrada', numero: 1 });


  const numEmpleado = localStorage.getItem('UserId')?.replace(/"/g, '');
  const usuarioIdEdicion = numEmpleado ? parseInt(numEmpleado) : 0;
const [newCheckTime, setNewCheckTime] = useState('');


const [showAddByEmployeeModal, setShowAddByEmployeeModal] = useState(false);
const [employeeNumber, setEmployeeNumber] = useState('');
const [checkDate, setCheckDate] = useState('');
const [checkTime, setCheckTime] = useState('');
const [checkType, setCheckType] = useState<'entrada' | 'salida'>('entrada');
const [checkNumber, setCheckNumber] = useState(1);
  const handleAddChecadaByEmployee = () => {
  // Validar que todos los campos estén llenos

  // Buscar el userId por número de empleado
    const empleado = data.find(item => item.numeroEmpleado === employeeNumber);
    if (!empleado) {
      mostrarToast('No se encontró el número de empleado en los datos cargados', 'Error', 'danger');
      return;
    }

  // Combinar fecha y hora
  // checkDate es string en formato YYYY-MM-DD
  // checkTime es string en formato HH:mm (puede ser datetime-local pero lo dividimos)
  // Necesitamos formar: YYYY-MM-DDTHH:mm:ss
  const fechaHora = `${checkDate}T${checkTime}:00`;

  // Validar formato
  if (!fechaHora.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
    mostrarToast('Formato de fecha y hora inválido', 'Error', 'danger');
    return;
  }

  const params: DTOGestionChecadasParams = {
    Accion: 'AGREGAR',
    userId: empleado.userId,
    checkTimeNuevo: fechaHora,
    checkTypeNuevo: checkType === 'entrada' ? 'I' : 'O',
    usuarioIdEdicion: usuarioIdEdicion,
  };

  RelojChecadorDataService.agregarChecada(params)
    .then((response) => {
      buscarDatos();
      mostrarToast('Checada agregada correctamente', 'Éxito', 'success');
        // setCheckEmployeeId(0);
      setCheckDate("");
      setCheckTime("");
      setCheckType("entrada");
      setEmployeeNumber("")
      setShowAddModal(false);
      // obtenerDatos();
      setShowAddByEmployeeModal(false);
      
    })

    
    .catch((error) => {
      console.error('Error al agregar:', error);
      mostrarToast(
        `Error al agregar la checada: ${error.response?.data?.message || error.message}`,
        'Error',
        'danger'
      );
    });
};





  const mostrarToast = (msg: string, header: string, color: string) => {
    setToastMsg(msg);
    setToastHeader(header);
    setToastColor(color);
    setShowToast(true);
  };

  const filtrar = (e: React.ChangeEvent<HTMLInputElement>) => {
    const texto = e.target.value.toLowerCase();
    setFiltro(texto);
    const filtrado = data.filter(
      (item) =>
        item.nombreEmpleado.toLowerCase().includes(texto) ||
        item.numeroEmpleado.toLowerCase().includes(texto) ||
        item.userId.toString().includes(texto)
    );
    setFilteredData(filtrado);
  };

  const exportarExcel = () => {
    const encabezado = [
      [
        'ID',
        'Nombre',
        'Número Empleado',
        'Fecha',
        'Entrada 1',
        'Salida 1',
        'Entrada 2',
        'Salida 2',
        'Entrada 3',
        'Salida 3',
        'Total Horas',
      ],
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, encabezado);
    XLSX.utils.sheet_add_json(ws, filteredData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'ReporteEntradasSalidas');
    XLSX.writeFile(wb, 'ReporteChecadas.xlsx');
  };

  const obtenerHoraChecada = (userId: number, fecha: string, tipo: 'entrada' | 'salida', numero: number): string => {
    const soloFecha = fecha.includes('T') ? fecha.split('T')[0] : fecha;
    console.log('Contenido de data:', JSON.stringify(data, null, 2));
    console.log('Buscando registro para:', { userId, fecha: soloFecha });

    const registro = data.find((item) => {
      const fechaItem = item.fecha.includes('T') ? item.fecha.split('T')[0] : item.fecha;
      return item.userId === userId && fechaItem === soloFecha;
    });

    console.log('Registro encontrado:', registro);

    if (!registro) {
      console.warn(`No se encontró registro para userId=${userId}, fecha=${soloFecha}`);
      mostrarToast(`No se encontró registro para el empleado ${userId} en la fecha ${soloFecha}`, 'Error', 'danger');
      return `${soloFecha}T00:00:00`;
    }

    const campo = `${tipo}${numero}` as keyof DTOReporteChecadas;
    console.log(`Accediendo a campo ${campo}:`, registro[campo]);

    const hora = registro[campo] as string | undefined;

    if (!hora || hora.trim() === '') {
      console.warn(`El campo ${campo} está vacío o undefined para userId=${userId}, fecha=${soloFecha}`);
      return `${soloFecha}T00:00:00`;
    }

    if (!hora.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
      console.warn(`Formato inválido para ${campo}: ${hora}`);
      return `${soloFecha}T00:00:00`;
    }

    console.log(`Hora encontrada para ${campo}:`, hora);
    return hora;
  };

  const handleEditChecada = () => {
    if (!newCheckTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
      mostrarToast('Formato de fecha inválido. Use YYYY-MM-DDTHH:mm:ss', 'Error', 'danger');
      return;
    }

    const params: DTOGestionChecadasParams = {
      Accion: 'EDITAR',
      userId: modalData.userId,
      checkTimeOriginal: modalData.checkTime!,
      checkTimeNuevo: newCheckTime,
      checkTypeNuevo: modalData.tipo === 'entrada' ? 'I' : 'O',
      usuarioIdEdicion: usuarioIdEdicion,
    };

    console.log('Objeto a enviar a la API:', JSON.stringify(params, null, 2));

    RelojChecadorDataService.gestionarChecada(params)
      .then((response) => {
        buscarDatos();
        mostrarToast('Cambio guardado', 'Éxito', 'success');
        setShowEditModal(false);
      })
      .catch((error) => {
        console.error('Error detallado:', {
          request: error.config?.data,
          response: error.response?.data,
        });
        mostrarToast(
          `Error al guardar: ${error.response?.data?.message || error.message}`,
          'Error',
          'danger'
        );
      });
  };

  const handleAddChecada = () => {
    if (!newCheckTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
      mostrarToast('Formato de fecha inválido. Use YYYY-MM-DDTHH:mm:ss', 'Error', 'danger');
      return;
    }

    const params: DTOGestionChecadasParams = {
      Accion: 'AGREGAR',
      userId: modalData.userId,
      checkTimeNuevo: newCheckTime,
      checkTypeNuevo: modalData.tipo === 'entrada' ? 'I' : 'O',
      usuarioIdEdicion: usuarioIdEdicion,
      
    };

    console.log('Enviando a API para agregar:', JSON.stringify(params, null, 2));

    RelojChecadorDataService.agregarChecada(params)
      .then((response) => {
        buscarDatos();
        mostrarToast('Checada agregada correctamente', 'Éxito', 'success');
        setShowAddModal(false);
      })
      .catch((error) => {
        console.error('Error al agregar:', error);
        mostrarToast(
          `Error al agregar la checada: ${error.response?.data?.message || error.message}`,
          'Error',
          'danger'
        );
      });
  };

  const handleDeleteChecada = () => {
    if (modalData.checkTime === `${modalData.fecha.includes('T') ? modalData.fecha.split('T')[0] : modalData.fecha}T00:00:00`) {
      mostrarToast('No se puede eliminar: hora inválida', 'Error', 'danger');
      setShowDeleteModal(false);
      return;
    }

    const params: DTOGestionChecadasParams = {
      Accion: 'ELIMINAR',
      userId: modalData.userId,
      checkTimeOriginal: modalData.checkTime!,
      usuarioIdEdicion: usuarioIdEdicion,
    };

    console.log('Enviando a API para eliminar:', JSON.stringify(params, null, 2));

    RelojChecadorDataService.eliminarChecada(params)
      .then((response) => {
        buscarDatos();
        mostrarToast('Checada eliminada correctamente', 'Éxito', 'success');
        setShowDeleteModal(false);
      })
      .catch((error) => {
        console.error('Error al eliminar:', error);
        mostrarToast(
          `Error al eliminar la checada: ${error.response?.data?.message || error.message}`,
          'Error',
          'danger'
        );
      });
  };

  const editarChecadaFinal = (userId: number, fecha: string, tipo: 'entrada' | 'salida', numero: number) => {
    const horaOriginal = obtenerHoraChecada(userId, fecha, tipo, numero);
    console.log('Valor exacto a usar como original:', horaOriginal);
    setModalData({ userId, fecha, tipo, numero, checkTime: horaOriginal });
    setNewCheckTime(horaOriginal);
    setShowEditModal(true);
  };

  const agregarChecada = (userId: number, fecha: string, tipo: 'entrada' | 'salida', numero: number) => {
    const soloFecha = fecha.includes('T') ? fecha.split('T')[0] : fecha;
    const defaultTime = `${soloFecha}T${new Date().toTimeString().slice(0, 8)}`;
    setModalData({ userId, fecha, tipo, numero });
    setNewCheckTime(defaultTime);
    setShowAddModal(true);
  };

  const eliminarChecada = (userId: number, fecha: string, tipo: 'entrada' | 'salida', numero: number) => {
    const checkTime = obtenerHoraChecada(userId, fecha, tipo, numero);
    setModalData({ userId, fecha, tipo, numero, checkTime });
    setShowDeleteModal(true);
  };

  const buscarDatos = () => {
    const hoy = new Date().toISOString().split('T')[0];
    const inicio = fechaInicio.trim() === '' ? hoy : fechaInicio;
    const fin = fechaFin.trim() === '' ? inicio : fechaFin;

    console.log('Ejecutando buscarDatos con:', { inicio, fin });

    RelojChecadorDataService.getReporteChecadas(inicio, fin)
      .then((response) => {
        setData(response.data);
        setFilteredData(response.data);
        mostrarToast('Datos cargados correctamente', 'Éxito', 'success');
      })
      .catch((error) => {
        console.error('Error al obtener datos:', error);
        console.error('Detalles del error:', error.response?.data || error.message);
        mostrarToast('Error al obtener los datos', 'Error', 'danger');
      });
  };

  useEffect(() => {
    buscarDatos();
  }, []);

  const columns = [
    { name: 'ID', selector: (row: DTOReporteChecadas) => row.userId, sortable: true, width: '80px' },
    { name: 'Nombre', selector: (row: DTOReporteChecadas) => row.nombreEmpleado, sortable: true },
    { name: 'NumEmpleado', selector: (row: DTOReporteChecadas) => row.numeroEmpleado, sortable: true },
    { name: 'Fecha', selector: (row: DTOReporteChecadas) => row.fecha, sortable: true, width: '120px' },
    {
      name: 'Entrada 1',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.entrada1 ? (
            <>
              {row.entrada1}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'entrada', 1)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'entrada', 1)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'entrada', 1)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Salida 1',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.salida1 ? (
            <>
              {row.salida1}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'salida', 1)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'salida', 1)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'salida', 1)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Entrada 2',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.entrada2 ? (
            <>
              {row.entrada2}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'entrada', 2)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'entrada', 2)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'entrada', 2)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Salida 2',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.salida2 ? (
            <>
              {row.salida2}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'salida', 2)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'salida', 2)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'salida', 2)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Entrada 3',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.entrada3 ? (
            <>
              {row.entrada3}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'entrada', 3)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'entrada', 3)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'entrada', 3)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Salida 3',
      cell: (row: DTOReporteChecadas) => (
        <span>
          {row.salida3 ? (
            <>
              {row.salida3}
              <span
                className="edit-btn"
                onClick={() => editarChecadaFinal(row.userId, row.fecha, 'salida', 3)}
                style={{ cursor: 'pointer', color: 'blue', marginLeft: '5px' }}
              >
                ✏️
              </span>
              <button
                className="btn btn-link p-0 ml-2"
                onClick={() => eliminarChecada(row.userId, row.fecha, 'salida', 3)}
              >
                <BsTrash style={{ color: 'red' }} />
              </button>
            </>
          ) : (
            <button
              className="btn btn-link p-0"
              onClick={() => agregarChecada(row.userId, row.fecha, 'salida', 3)}
            >
              <BsPlusCircle style={{ color: 'green' }} />
            </button>
          )}
        </span>
      ),
    },
    {
      name: 'Total Horas',
      selector: (row: DTOReporteChecadas) => row.totalHoras || '',
      sortable: true,
    },
  ];

  return (
    <div className="mt-3">
      <Card>
        <Card.Body>
          <Row className="align-items-end">
            <Col xs={3}>
              <Form.Control
                type="text"
                placeholder="Buscar por nombre, ID o número"
                value={filtro}
                onChange={filtrar}
              />
            </Col>
            <Col xs={2}>
              <Form.Label>Fecha inicio</Form.Label>
              <Form.Control
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </Col>
            <Col xs={2}>
              <Form.Label>Fecha fin</Form.Label>
              <Form.Control
                type="date"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
              />
            </Col>
            <Col xs={2}>
              <Button variant="primary" onClick={buscarDatos}>
                Buscar
              </Button>
            </Col>

                  <Col xs={1}>
        <Button variant="warning" onClick={() => setShowAddByEmployeeModal(true)}>
          <BsPlusCircle />
          &nbsp;Agregar Checada
        </Button>
      </Col>  
            <Col xs={2}>
              <Button variant="success" onClick={exportarExcel}>
                <BsFileEarmarkExcel />
                &nbsp;Excel
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <MsgInformativo
        show={showToast}
        msg={toastMsg}
        header={toastHeader}
        msgColor={toastColor}
        closeToast={() => setShowToast(false)}
      />

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Checada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                Editando {modalData.tipo} {modalData.numero} para empleado {modalData.userId}
              </Form.Label>
              <Form.Label className="d-block">Fecha: {modalData.fecha.split('T')[0]}</Form.Label>
              <Form.Label className="d-block">Actual: {modalData.checkTime}</Form.Label>
              <Form.Control
                type="text"
                placeholder="YYYY-MM-DDTHH:mm:ss"
                value={newCheckTime}
                onChange={(e) => setNewCheckTime(e.target.value)}
              />
              <Form.Text className="text-muted">
                Ingrese la fecha y hora en formato: YYYY-MM-DDTHH:mm:ss
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleEditChecada}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Checada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                Agregando {modalData.tipo} {modalData.numero} para empleado {modalData.userId}
              </Form.Label>
              <Form.Label className="d-block">Fecha: {modalData.fecha.split('T')[0]}</Form.Label>
              <Form.Control
                type="text"
                placeholder="YYYY-MM-DDTHH:mm:ss"
                value={newCheckTime}
                onChange={(e) => setNewCheckTime(e.target.value)}
              />
              <Form.Text className="text-muted">
                Ingrese la fecha y hora en formato: YYYY-MM-DDTHH:mm:ss
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleAddChecada}>
            Agregar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Checada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            ¿Estás seguro de eliminar la checada {modalData.tipo} {modalData.numero} ({modalData.checkTime}) para el
            empleado {modalData.userId}?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteChecada}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>

      <Card className="mt-3">
        <Card.Body>
          <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
            <DataTable
              noHeader
              defaultSortAsc={true}
              striped
              dense
              paginationPerPage={10}
              pagination
              highlightOnHover
              columns={columns}
              data={filteredData}
            />
          </div>
        </Card.Body>
      </Card>

      <Modal show={showAddByEmployeeModal} onHide={() => setShowAddByEmployeeModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Agregar Checada por Número de Empleado</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>Número de Empleado *</Form.Label>
        <Form.Control
          type="text"
          value={employeeNumber}
          onChange={(e) => setEmployeeNumber(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Fecha *</Form.Label>
        <Form.Control
          type="date"
          value={checkDate}
          onChange={(e) => setCheckDate(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Hora *</Form.Label>
        <Form.Control
          type="time"
          value={checkTime}
          onChange={(e) => setCheckTime(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Tipo de Checada *</Form.Label>
        <Form.Select
          value={checkType}
          onChange={(e) => setCheckType(e.target.value as 'entrada' | 'salida')}
        >
          <option value="entrada">Entrada</option>
          <option value="salida">Salida</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Número de Checada *</Form.Label>
        <Form.Select
          value={checkNumber}
          onChange={(e) => setCheckNumber(parseInt(e.target.value))}
        >
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
        </Form.Select>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowAddByEmployeeModal(false)}>
      Cancelar
    </Button>
    <Button variant="primary" onClick={handleAddChecadaByEmployee}>
      Agregar
    </Button>
  </Modal.Footer>

  
</Modal>
    </div>
  );
}



/////ORIGINAL 



